export const BASE_URL = window.origin;
export const API_URL = '';
export const SHEETS_API_URL = 'https://sheets.googleapis.com/v4/spreadsheets/';
export const API_KEY = "AIzaSyDgXNamDcyAjiee8_f5W4snn0gn9HoXNhU";
